import React from 'react';
import { ArrowRight } from 'lucide-react';
import { trackAddToCart } from '../../utils/pixel';
interface CTAButtonProps {
  text?: string;
  className?: string;
  onClick?: () => void;
  href?: string;
}
export function CTAButton({
  text = 'QUIERO EMPEZAR EL PLAN DE 7 DÍAS',
  className = '',
  onClick,
  href = 'https://pay.hotmart.com/Q105139029S?checkoutMode=10'
}: CTAButtonProps) {
  const handleClick = () => {
    trackAddToCart();
    onClick?.();
  };
  const baseClasses = `
    group relative inline-flex items-center justify-center gap-3 
    bg-terracotta text-white font-bold text-sm md:text-base tracking-wide
    py-4 px-8 rounded-xl w-full md:w-auto
    shadow-[0_6px_0_#9A452E,0_15px_20px_rgba(183,85,59,0.3)]
    active:shadow-[0_0px_0_#9A452E,0_0px_0_rgba(183,85,59,0.3)]
    active:translate-y-[6px]
    transition-all duration-150 ease-out
    overflow-hidden
    ${className}
  `;
  const content = <>
      <span className="relative z-10" data-id="element-231">{text}</span>
      <ArrowRight className="w-5 h-5 relative z-10 group-hover:translate-x-1 transition-transform duration-300" strokeWidth={2.5} data-id="element-232" />
      <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out z-0 rounded-xl" data-id="element-233" />
    </>;
  if (href && !onClick) {
    return <a href={href} onClick={handleClick} className={baseClasses} data-id="element-234">
        {content}
      </a>;
  }
  return <button onClick={handleClick} className={baseClasses} data-id="element-235">
      {content}
    </button>;
}